export default __webpack_public_path__ + "static/dog-vaccination-5db14f42488575f068c6874ecc24297b.jpg";